export default function MySQL_COMMENTS() {
  return (
    <div>
      <h2>MySQL_COMMENTS</h2>    </div>
  );
}